module.exports = __webpack_public_path__ + "static/img/djdl.5364dff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/djdl.jpg
// module id = d5Tk
// module chunks = 4